import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import Box from '@mui/material/Box';
import moment from 'moment';

// Icons 

import MoreVertIcon from '@mui/icons-material/MoreVert';
import getStatusColor from '../../../../util/style/getStatusColor';
import { getDoctorName, getGroupMemberInfo } from '../../../../routes/hacker/users';
import getCapitalizedString from '../../../../util/style/getCapitalizedString';

type Props = {
    item: any; 
};


const GroupAccessRow: React.FC<Props> = ({ item }) => {

  const colors = useAppSelector(state => state.theme.colors); 
  const selectedGroup = useAppSelector((state) => state.groupsAccess.selectedGroup); 

  const [doctorName, setDoctorName] = useState(''); 
  const [status, setStatus] = useState(''); 

  // -- 

  const handleDoctorInfo = async () => { 

    const res = await getGroupMemberInfo(item._id) as any; 

    if (res.data.status === 200) { 

      setDoctorName(`${res.data.doctor.firstName} ${res.data.doctor.lastName}`); 

      if (res.data.isMainDoctorId) { 

        setStatus('admin'); 

      }; 

    }; 

  }; 

  // -- 

  useEffect(() => { 

    if (item) { 

      handleDoctorInfo(); 

      setStatus(item.status); 

    }; 

  },[item]); 

  return (

    <Box 
      sx={{ 
      display: 'flex', 
      flexDirection: 'row',
      alignItems: 'center', 
      width: '100%',
      fontSize: 12, 
      height: 50,
      backgroundColor: (selectedGroup?._id == item?._id) ? colors?.sectionHover : 'transparent', 
      '&:hover': { backgroundColor: colors?.sectionHover }
    }}>

            <div style={{ 
                display: 'flex', 
                flexDirection: 'row',
                alignItems: 'center',
                width: '73%',
                marginLeft: '2%',  
                textAlign: 'left',
                overflow: 'hidden',
            }}>{doctorName}</div>

            <div style={{ 
                width: '15%', 
                textAlign: 'left',
                overflow: 'hidden', 
            }}>                
            
              <strong 
                style={{ 
                  padding: 5,
                  borderRadius: 7,
                  backgroundColor: getStatusColor(status), 
                  color: 'white', 
                }}>
              {getCapitalizedString(status)}
              </strong>
          </div>

            <div style={{ 
                width: '10%', 
                textAlign: 'left',
                overflow: 'hidden', 
            }}>
                <Box
                  sx={{ 
                    display: 'flex', 
                    flexDirection: 'row',
                    alignItems: 'center', 
                    justifyContent: 'space-evenly', 
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    '&:hover': { backgroundColor: 'rgba(45, 153, 207, 0.6)'}
                  }}
                >
                  <MoreVertIcon></MoreVertIcon>
                </Box>

            </div>

    </Box>

  );

};

export default GroupAccessRow;